import React from 'react';

const InactivityInfoModal = ({ onClose }) => {
  return (
    <div
      style={{
        padding: '20px',
        maxWidth: 360,
        width: '100%',
        backgroundColor: '#fff',
        borderRadius: '6px',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
        textAlign: 'center',
      }}>
      <h3
        style={{
          margin: '0 0 8px 0',
          fontSize: '18px',
          fontWeight: 600,
          color: '#1a1a1a',
        }}>
        You were logged out
      </h3>
      <p
        style={{
          margin: '0 0 16px 0',
          fontSize: '14px',
          color: '#4a5568',
          lineHeight: 1.5,
        }}>
        Your session ended due to inactivity. Please sign in again to continue.
      </p>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        <button
          className="btn btn_primary"
          onClick={onClose}
          style={{
            minWidth: '80px',
          }}>
          OK
        </button>
      </div>
    </div>
  );
};

export default InactivityInfoModal;
